
import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaArrowCircleRight, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function OneService({ image, title, navToLink = {} }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	
	return (
		<div 
			className="card"
			style={{
				height: "300px",
				cursor: "pointer",
				backgroundImage: `url(${image})`,
				backgroundPosition: "center",
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
				position: 'relative',
				overflow: "hidden"
			}}

			onClick={() => {
				appContext.navTo(navToLink)
			}}
		>
			
			<div
				style={{
					width: "100%",
					height: "100%",
					background: "linear-gradient(to top, rgba(1, 153, 82,0.9) 0%, rgba(1, 153, 82, 0.3) 30%, rgba(1, 153, 82, 0) 100%)",
					position: "relative",
				}}
			>
			</div>


			<div 
				style={{
					width: "100%",
					height: "auto",
					position: "absolute",
					padding: "20px",
					bottom: 0,
					left: 0,
				}}
			>
				<div 
					className="d-flex justify-content-between"
					style={{
						height: "100%"
					}}
				>
					<h6
						style={{
							fontSize: "18px",
							flex: 1,              // take remaining space
							minWidth: 0,          // allow wrapping properly
							textTransform: "uppercase",
							marginRight: "8px",   // spacing from icon
							wordBreak: "break-word", // break long words instead of overflowing
						}}
						className="font-bold align-self-center text-light mNoMargin"
					>
						{title}
					</h6>

					<FaArrowCircleRight
						className="align-self-center text-light"
						size={32}
						style={{
							flexShrink: 0,
							cursor: "pointer",
						}}
					/>
				</div>

			</div>
		</div>
	)
	

	
}
